// Create types
export const PAYMENT_CREATE_ERROR = 'PAYMENT_CREATE_ERROR';
export const PAYMENT_CREATE_LOADING = 'PAYMENT_CREATE_LOADING';
export const PAYMENT_CREATE_SUCCESS = 'PAYMENT_CREATE_SUCCESS';
export const PAYMENT_CREATE_VIOLATIONS = 'PAYMENT_CREATE_VIOLATIONS';
export const PAYMENT_CREATE_RESET = 'PAYMENT_CREATE_RESET';

// Delete types
export const PAYMENT_DELETE_ERROR = 'PAYMENT_DELETE_ERROR';
export const PAYMENT_DELETE_LOADING = 'PAYMENT_DELETE_LOADING';
export const PAYMENT_DELETE_SUCCESS = 'PAYMENT_DELETE_SUCCESS';
export const PAYMENT_DELETE_RESET = 'PAYMENT_DELETE_RESET';

// List types
export const PAYMENT_LIST_ERROR = 'PAYMENT_LIST_ERROR';
export const PAYMENT_LIST_LOADING = 'PAYMENT_LIST_LOADING';
export const PAYMENT_LIST_RESET = 'PAYMENT_LIST_RESET';
export const PAYMENT_LIST_PAGINATION = 'PAYMENT_LIST_PAGINATION';
export const PAYMENT_LIST_SUCCESS = 'PAYMENT_LIST_SUCCESS';
export const PAYMENT_LIST_ORDER = 'PAYMENT_LIST_ORDER';
export const PAYMENT_LIST_PAGE = 'PAYMENT_LIST_PAGE';
export const PAYMENT_LIST_FILTER = 'PAYMENT_LIST_FILTER';


// WEBPACK FOOTER //
// ./src/store/modules/payment/mutation-types.js